import { cn } from '../../lib/cn';
import type { WorkflowRow } from '../../automationstudio/framework';

type Props = { workflows?: WorkflowRow[] };

export function WorkflowDesignerPanel({ workflows = [] }: Props) {
  return (
    <div className="space-y-2">
      {workflows.map((w) => (
        <div key={w.name} className="flex items-center justify-between gap-3 rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <div className="min-w-0 flex-1">
            <p className="text-sm font-medium">{w.name}</p>
            <p className="mt-0.5 text-xs text-slate-500">{w.steps} steps · {w.triggers}</p>
          </div>
          <div className="shrink-0 text-right">
            <span className={cn(
              'rounded-full px-2 py-0.5 text-xs font-medium',
              w.status === 'running' ? 'bg-brand-50 text-brand-700 dark:bg-brand-950 dark:text-brand-300' : 'bg-success-50 text-success-700 dark:bg-success-950 dark:text-success-300',
            )}>
              {w.status}
            </span>
            <p className="mt-1 text-xs text-slate-500">{w.success}% success</p>
          </div>
        </div>
      ))}
    </div>
  );
}
